module.exports = __webpack_public_path__ + "static/media/fl.ae8e467.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/fl.mp4
// module id = K4xg
// module chunks = 1